
  <div class="invitation-banner">
    <div class="image-column"></div>
    <div class="info-column">
      <div class="info-content">
        <h1>{{title}}</h1>
        <h2>{{subtitle}}</h2>
        <ng-content></ng-content>
      </div>
    </div>
  </div>
  